import { Link } from 'react-router-dom';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import usePageTitle from '../hooks/usePageTitle';

// The catch-all route. Without it React Router renders an empty tree for an
// unknown path, which reads as a broken site rather than a wrong address.
function NotFoundPage() {
  usePageTitle('Page Not Found');

  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      <main className="flex-1 flex items-center justify-center px-4 py-16 bg-gradient-to-br from-gray-50 to-gray-100">
        <div className="max-w-md w-full text-center">
          <p className="text-6xl font-bold mb-4" style={{ color: '#a60533' }}>
            404
          </p>
          <h1 className="text-3xl font-bold text-gray-900 mb-3">
            Page not found
          </h1>
          <p className="text-gray-600 mb-8">
            We cannot find that page. It may have moved, or the address may be
            mistyped.
          </p>
          <div className="space-y-3">
            <Link
              to="/"
              className="block w-full py-3 px-6 text-white rounded-lg font-semibold transition-all duration-200"
              style={{ backgroundColor: '#a60533' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#8a0429'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#a60533'}
            >
              Go to the home page
            </Link>
            <Link
              to="/contact"
              className="block w-full py-3 px-6 rounded-lg font-semibold border-2 transition-all duration-200"
              style={{ color: '#a60533', borderColor: '#a60533' }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#fce7ed'}
              onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
            >
              Contact support
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default NotFoundPage;
